module.exports = __webpack_public_path__ + "static/ariston_768-ca210f56f29491ce48cd30e3ee133a27.png";